import { Box } from '@mui/material';
import React from 'react';
import { Outlet } from 'react-router-dom';
export const SalesWizardLayout = () => {
    return (React.createElement(Box, { component: "div", sx: { width: '100%' } },
        React.createElement(Outlet, null)));
};
